import Button from "@/components/input/Button";
import { ANIMATION_CLASSNAMES, getViewPortHeightCssString } from "@/styles";
import styled from "@emotion/styled";
import React, { useState } from "react";

const StyledPanel = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background: rgba(255, 255, 255, 0.9);
  border: 2px dashed red;

  & > *:first-child {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const StyledDvh = styled(StyledPanel)`
  height: 100dvh;
`;

const StyledVh = styled(StyledPanel)`
  height: 100vh;
`;

const StyledCustomVh = styled(StyledPanel)`
  height: ${getViewPortHeightCssString()};
`;

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  & > * {
    border: 1px solid gray;
    width: 100%;
    padding: 1rem;
    text-align: center;
  }

  & > div {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    overflow: auto;
    font-size: 2rem;
    padding: 0;
  }

  & > div > div {
    min-height: 120vh;
    width: 100%;
  }
`;

const HeightTest: React.FC = () => {
  const [type, setType] = useState<"" | "dvh" | "vh" | "custom-vh">();

  const closeButton = (
    <Button
      className="mt-3 w-100"
      variant="secondary"
      onClick={() => {
        setType("");
      }}
    >
      Close
    </Button>
  );

  const content = (children: any) => (
    <StyledContent>
      <header>header</header>
      <div>
        <div>
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
          {children}
        </div>
      </div>
      <footer>footer {closeButton}</footer>
    </StyledContent>
  );

  if (!type) {
    return (
      <div>
        <p>
          Click a solution. IT will open a full screen panel in that solution.
          Check if the screen border fits the whole screen properly
        </p>
        <Button
          className="w-100 mt-3"
          variant="secondary"
          onClick={() => {
            setType("dvh");
          }}
        >
          Solution 1 - DVH
        </Button>
        <Button
          className="w-100 mt-3"
          variant="secondary"
          onClick={() => {
            setType("vh");
          }}
        >
          Solution 2 - VH
        </Button>
        <Button
          className="w-100 mt-3"
          variant="secondary"
          onClick={() => {
            setType("custom-vh");
          }}
        >
          Solution 3 - Custom VH
        </Button>
      </div>
    );
  }

  if (type === "dvh") {
    return (
      <StyledDvh className={ANIMATION_CLASSNAMES.FADE_IN}>
        {content(<p>Solution 1 - DVH</p>)}
      </StyledDvh>
    );
  }

  if (type === "vh") {
    return (
      <StyledVh className={ANIMATION_CLASSNAMES.FADE_IN}>
        {content(<p>Solution 2 - VH</p>)}
      </StyledVh>
    );
  }

  if (type === "custom-vh") {
    return (
      <StyledCustomVh className={ANIMATION_CLASSNAMES.FADE_IN}>
        {content(<p>Solution 2 - VH</p>)}
      </StyledCustomVh>
    );
  }
};

export default HeightTest;
